import React from 'react';
import Widget from '../Widget/Widget.js'
import YouTube from 'react-youtube';
import './YouTubeWidget.css'


class YouTubeWidget extends React.Component {

  renderVideo() {
    //video
    const opts = {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
        loop:this.props.loop ? 1 : 0,
        modestbranding:1,
        showinfo:0,
        playlist:this.props.videoId,
        iv_load_policy:1,
        cc_load_policy:this.props.displayClosedCaptions ? 1 : 0,
        cc_lang_pref:"en",
        controls:0
      }
    };

    return (
      <YouTube
        videoId={this.props.videoId}
        opts={opts}
      />
    )
  }

  renderPlaylist() {
    const opts = {
      height: '100%',
      width: '100%',
      playerVars: {
        autoplay: 1,
        loop:this.props.loop ? 1 : 0,
        modestbranding:1,
        showinfo:0,
        list:this.props.videoId,
        iv_load_policy:1,
        listType:"playlist",
        cc_load_policy:this.props.displayClosedCaptions ? 1 : 0,
        cc_lang_pref:"en",
        controls:0
      }
    };

    return (
      <YouTube
        opts={opts}
      />
    )
  }


  render() {

    var player;

    if(this.props.isPlaylist) {
      player = this.renderPlaylist()
    } else {
      player = this.renderVideo()
    }


    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center youtube-widget-col">
            {player}
          </div>
        </div>
      </Widget>
    )
  }
}

export default YouTubeWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/YouTubeWidget/YouTubeWidget.js